module.exports = function() {
  return new Worker(__webpack_public_path__ + "be0413ee3dc035cbaa2a.worker.js");
};